import { type ReactNode } from 'react';

import type { InternalDropdownOption } from '~/chords/Select/components/DropdownSingleSelect/types';
import { getSearchHighlightRanges } from '~/chords/Select/components/DropdownSingleSelect/utils/getSearchHighlightRanges';
import { getSearchMatchTokens } from '~/chords/Select/components/DropdownSingleSelect/utils/getSearchMatchTokens';

export function DropdownItemLabel({
  option,
  searchQuery,
}: {
  option: InternalDropdownOption;
  searchQuery?: string;
}) {
  const optionLabel = option.label || option.value;

  if (option.disabled) {
    return <span className="text-emphasis-stronger">{optionLabel}</span>;
  }

  if (!searchQuery) {
    return optionLabel;
  }

  const searchTerms = getSearchMatchTokens(searchQuery);
  const ranges = getSearchHighlightRanges(optionLabel, searchTerms);

  if (ranges.length === 0) {
    return <span className="text-emphasis-stronger">{optionLabel}</span>;
  }

  const parts: ReactNode[] = [];
  let cursor = 0;

  ranges.forEach((range, rangeIndex) => {
    if (cursor < range.start) {
      parts.push(optionLabel.slice(cursor, range.start));
    }

    parts.push(
      <mark key={rangeIndex} className="bg-transparent text-default">
        {optionLabel.slice(range.start, range.end)}
      </mark>,
    );

    cursor = range.end;
  });

  if (cursor < optionLabel.length) {
    parts.push(optionLabel.slice(cursor));
  }

  return <span className="text-emphasis-stronger">{parts}</span>;
}

DropdownItemLabel.displayName = 'DropdownItemLabel';
